import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b94a1b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center position-fixed bottom-0 w-100 bg-greeny",
  style: {"padding":"1.5rem 1.5rem","z-index":"4000"}
}
const _hoisted_2 = {
  id: "container-footer-actions",
  class: "d-flex justify-content-between"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2-square" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-down-up" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import {ref} from "vue";
import FullscreenActions from "@/components/gallery/FullscreenActions.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  show: {
    type: Boolean
  }
},
  emits: ["selectionModeToggled", "scrollModeToggled", "deletionTriggered"],
  setup(__props, { emit }: { emit: ({
  (e: 'selectionModeToggled', value: boolean):void
  (e: 'scrollModeToggled', value: boolean):void
  (e: 'deletionTriggered'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const selectionMode = ref<boolean>(false)
const toggleSelectionMode = () => {
  selectionMode.value = !selectionMode.value
  emit('selectionModeToggled', selectionMode.value)
}

const scrollMode = ref<boolean>(false)
const toggleScrollMode = () => {
  scrollMode.value = !scrollMode.value
  emit('scrollModeToggled', scrollMode.value)
}

const showDeprecated = ref<boolean>(false)


return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            class: "button-primary round",
            onClick: toggleSelectionMode
          }, _hoisted_4),
          _createElementVNode("button", {
            class: "round",
            type: "button",
            onClick: _cache[0] || (_cache[0] = () => emit('deletionTriggered'))
          }, _hoisted_6),
          _createElementVNode("button", {
            type: "button",
            class: "round",
            onClick: toggleScrollMode
          }, _hoisted_8),
          _createVNode(FullscreenActions)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})